import {
  IGNORED_ERROR_TARGETS,
  IGNORED_STACK_FILENAMES,
} from "~/constants/ignorable-errors";

const matchesAny = (value: string, patterns: string[]): boolean =>
  patterns.some((p) => value.includes(p));

export default defineNuxtPlugin(() => {
  const bugsnag = useBugsnag();

  bugsnag.addOnError((event) => {
    const frames = event.errors.flatMap((e) => e.stacktrace ?? []);
    const messages = event.errors.map((e) =>
      (e.errorMessage ?? "").toLowerCase(),
    );

    const err = event.originalError;
    const domTarget = err instanceof Event ? err.target : undefined;
    const element = domTarget instanceof Element ? domTarget : undefined;
    const target = (element?.className || element?.id || "").toLowerCase();

    const normalizedFilenames = frames.map((f) => (f.file ?? "").toLowerCase());

    // When a promise rejects with a plain string Bugsnag wraps it as an
    // 'InvalidError' and loses the original value from errors[].errorMessage.
    // The raw rejection string is only preserved on originalError itself.
    const originalErrorStr =
      typeof err === "string" ? err.toLowerCase() : "";

    const shouldIgnore =
      matchesAny(target, IGNORED_ERROR_TARGETS) ||
      messages.some((m) => matchesAny(m, IGNORED_ERROR_TARGETS)) ||
      (originalErrorStr !== "" &&
        matchesAny(originalErrorStr, IGNORED_ERROR_TARGETS)) ||
      normalizedFilenames.some((f) => matchesAny(f, IGNORED_STACK_FILENAMES));

    return !shouldIgnore;
  });
});
